import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { useMutation } from 'react-query';
import { useParams, useHistory, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Spinner, Card, CardBody, Button } from 'reactstrap';
import {useDropzone} from 'react-dropzone'
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import clsx from 'clsx';

import MainLayout from '../../layouts/MainLayout';
import mailIcon from '../../images/pdf/file-send.svg'

import {EditorDocumentPreview} from "../../components/DocumentPreview";

import { EditorProvider, useEditorState, useEditorActions, SET_DOCUMENT } from '../../context/editor';
import { TestamentConfiguration } from './TestamentConfiguration';
import { useAuthState } from '../../context/auth';
 
function TestamentEditor() {
  const { t } = useTranslation('common');
  const [hasSucceed, setHasSucceed] = useState(false);
  const auth = useAuthState();

  const { documentId, status } = useEditorState();

  return (
    <MainLayout className='p-0' footer={false} banner={!auth?.accessToken && { message: t('Crea tu cuenta para ver otras plantillas'), icon: 'file'}} showUpgradeBanner={false}> 
      { !documentId && status === 'loading' && 
        <Container className="d-flex flex-column justify-content-center align-items-center mvh-75 ">
          <Spinner  size="lg" />
          <span>{t('actions.loading')}</span>
        </Container>
      }
      { documentId && status === 'success' && !hasSucceed && 
        <Container fluid className={clsx("d-flex p-0 overflow-hidden h-100")}>
          <Row noGutters className="p-0 w-100 h-100 max-h-with-navbar">
              <Col lg={8} className="p-4 h-100 overflow-auto">
                <EditorDocumentPreview card header={true} width={600} />
              </Col>
              <Col lg={4}>
                <TestamentConfiguration className="max-h-with-navbar" templateId={documentId} onTestamentSent={() => setHasSucceed(true)} />
              </Col>
          </Row>
        </Container>
      }
      {
        hasSucceed && status === 'success' && 
        <Container fluid className={clsx("d-flex p-5 overflow-hidden h-100 justify-content-center align-items-center")}>
          <Card className="mx-auto border-0 shadow-sm my-5">
            <CardBody className="text-center pt-4 px-5 pb-5">
              <img src={mailIcon} className="img-fluid mb-4 icon-md" alt="mail icon" />
                <h2 className="font-weight-bold mb-1">{t('contractSent.title', { context: 'testament' })}</h2>
                <p className="text-muted mb-4">
                    {t('contractSent.subtitle')}
                </p>
                <Button 
                  className="shadow-sm"
                  color="accent"       
                  tag={Link}      
                  to='/documents'     
                >
                  {t('myDocuments')}
                </Button>
            </CardBody>
          </Card>
        </Container>
    }
    </MainLayout>
  )
}

function TestamentEditorContainer() {
  const { publicTemplateId, templateId } = useParams();

  return (
    <EditorProvider documentId={publicTemplateId || templateId} mode={publicTemplateId ? "public-template" : 'template'}>
      <TestamentEditor />
    </EditorProvider>
  )
}


export default TestamentEditorContainer

